'use strict';

var Sugar = require('sugar-core'),
    arrayRemove = require('./internal/arrayRemove');

Sugar.Array.defineInstance({

  'remove': function(arr, f) {
    return arrayRemove(arr, f);
  }

});

module.exports = Sugar.Array.remove;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/remove.js
// module id = 418
// module chunks = 0